import { LocaleKeys, watermarkEvents } from '@sharefiledev/fileviewer-pilet-sdk';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Locale } from '@sharefiledev/sharing-pilet-sdk';

export interface WatermarkConfig {
	transformedRids: string[];
	success: boolean;
	labels: Locale<LocaleKeys>[];
	pluginName: string;
}

export function emitWatermarkRequest(piletApi: PiletApi, rids: string[]) {
	if (rids.length > 0) {
		piletApi.emit(watermarkEvents.GetTransformedRids, {
			resourceIds: rids,
		});
	}
}

/**
 * Listens for watermark response and calls the provided callback with the result.
 */
export function listenForWatermarkResponse(
	piletApi: PiletApi,
	onResponse: (response: WatermarkConfig) => void
) {
	const handler = (data: {
		transformedRids: string[];
		success: boolean;
		labels: Locale<LocaleKeys>[];
		pluginName: string;
	}) => {
		onResponse({
			transformedRids: data.transformedRids ?? [],
			success: data.success,
			labels: data.labels ?? [],
			pluginName: data.pluginName ?? '',
		});
	};

	piletApi.on(watermarkEvents.TransformedRidsResponse, handler);

	return () => {
		piletApi.off(watermarkEvents.TransformedRidsResponse, handler);
	};
}
